import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SitesViewComponent } from './site-view.component';
import { SquareViewComponent } from './square-view/square-view.component';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';

@NgModule({
  declarations: [SitesViewComponent, SquareViewComponent],
  imports: [CommonModule, SharedLayoutModule, WithTooltipModule],
})
export class SitesViewModule {}
